<div style="width: 100%">
    <table class="table diagram_table">
        <thead>
            <tr *ngIf="diagramDimensions !== null">
                <ng-container *transloco="let t; read: 'STANDARD_FLANGE_PAGE.LABELS.DIAGRAM_INPUT'">
                    <th>{{ t('TABLE_KEY') }}</th>
                    <th>{{ t('TABLE_DIMENSION') }}</th>
                    <th>{{ t('TABLE_VALUE') }}</th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of diagramDimensions">
                <td>{{ diagramMappings.get(item.key).abbreviation }}</td>
                <td>{{ diagramMappings.get(item.key).displayText }}</td>
                <td>{{ diagramMappings.get(item.key).value }}</td>
            </tr>
        </tbody>
    </table>
</div>
